<template>
    <a
        class="link-preview-card"
        :class="{ 'has-image': !!imageSrc }"
        :href="href"
        target="_blank"
        rel="noopener noreferrer nofollow"
        :title="href"
        @click.stop
    >
        <div v-if="imageSrc" class="link-preview-card__image">
            <img :src="imageSrc" :alt="preview.title || preview.domain || ''" loading="lazy" @error="imageFailed = true" />
        </div>
        <div class="link-preview-card__body">
            <div v-if="preview.title" class="link-preview-card__title">{{ preview.title }}</div>
            <div v-if="preview.description" class="link-preview-card__description">{{ preview.description }}</div>
            <div class="link-preview-card__domain">
                <img
                    v-if="faviconSrc"
                    :src="faviconSrc"
                    class="link-preview-card__favicon"
                    alt=""
                    @error="faviconFailed = true"
                />
                <a-icon v-else type="link" class="link-preview-card__link-icon" />
                <span>{{ preview.siteName || preview.domain || hostname }}</span>
            </div>
        </div>
    </a>
</template>

<script>
/**
 * Mesaj metnindeki linkin Open Graph kartı (WhatsApp tarzı). Mesajın populate edilmiş
 * `linkPreview` alanını alır; görsel yüklenemezse görselsiz düzene düşer.
 */
export default {
    name: "LinkPreviewCard",
    props: {
        preview: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            imageFailed: false,
            faviconFailed: false,
        };
    },
    computed: {
        href() {
            return this.preview.finalUrl || this.preview.url || "#";
        },
        hostname() {
            try {
                return new URL(this.href).hostname.replace(/^www\./, "");
            } catch (e) {
                return "";
            }
        },
        imageSrc() {
            return !this.imageFailed && this.preview.image ? this.preview.image : null;
        },
        faviconSrc() {
            return !this.faviconFailed && this.preview.favicon ? this.preview.favicon : null;
        },
    },
    watch: {
        "preview.image"() {
            this.imageFailed = false;
        },
        "preview.favicon"() {
            this.faviconFailed = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.link-preview-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 200px;
    max-width: 320px;
    margin: 4px 0 8px;
    border-radius: var(--sps-radius-md, 8px);
    overflow: hidden;
    background: rgba(0, 0, 0, 0.08);
    color: inherit !important;
    text-decoration: none !important;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.14);
        color: inherit;
        text-decoration: none;
    }

    &__image {
        width: 100%;
        max-height: 160px;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.06);

        img {
            display: block;
            width: 100%;
            max-height: 160px;
            object-fit: cover;
        }
    }

    &__body {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 8px 10px;
        min-width: 0;
    }

    &__title {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.3;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    &__description {
        font-size: 12px;
        line-height: 1.35;
        opacity: 0.8;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    &__domain {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-top: 2px;
        font-size: 11px;
        opacity: 0.7;
        white-space: nowrap;
        overflow: hidden;

        span {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &__favicon {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        flex: 0 0 auto;
        object-fit: contain;
    }

    &__link-icon {
        font-size: 13px;
        flex: 0 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/LinkPreviewCard.vue